import React from 'react';

const Info = () => (
  <div>
    <h2>Weather in your city</h2>
    <p>Find out the weather in your city</p>
  </div>
);

export default Info;
